module.exports = __webpack_public_path__ + "static/media/phcs.80833e01.jpg";